import coupleImg1 from '../../images/couple/image-4.jpg'
import coupleImg2 from '../../images/couple/image-5.jpg'
import coupleImg3 from '../../images/couple/image-6.jpg'
import coupleImg4 from '../../images/couple/image-7.jpg'
import shape from '../../images/couple/love-birds.svg'


const CoupleSection3: React.FC = () => {

    return (
        <section className="wpo-couple-section-s3 section-padding">
            <div className="container-fluid">
                <div className="couple-wrap">
                    <div className="row text-center">
                        <div className="col col-lg-3 col-md-12 col-12">
                            <div className="couple-items wow fadeInLeftSlow" data-wow-duration="1400ms">
                                <div className="image">
                                    <img src={coupleImg3} alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-6 col-md-12 col-12">
                            <div className="couple-items wow fadeInUp" data-wow-duration="1000ms">
                                <div className="couple-middle-items">
                                    <div className="couple-middle-content">
                                        <div className="image">
                                            <img src={coupleImg1} alt=""/>
                                        </div>
                                        <div className="couple-text">
                                            <h2>Amanda Jenny</h2>
                                            <p>A heart full of love and a soul full of hope, I can't wait to begin this
                                                journey with you by my side.</p>

                                        </div>
                                    </div>
                                    <div className="couple-middle-content">
                                        <div className="image">
                                            <img src={coupleImg2} alt=""/>
                                        </div>
                                        <div className="couple-text">
                                            <h2>Max Wilson</h2>
                                            <p>Today, I marry my best friend. With joy in my heart and love in my eyes,
                                                I’m
                                                ready
                                                for forever</p>
                                        </div>
                                    </div>
                                    <div className="love-birds">
                                        <img src={shape} alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-12 col-12">
                            <div className="couple-items wow fadeInRightSlow" data-wow-duration="1400ms">
                                <div className="image">
                                    <img src={coupleImg4} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CoupleSection3;